"use strict";
/**
 *
 * WARNING: Before changing this file, please strongly consider whether your change is
 * necessary (we want to avoid unexpected bugs in other views).
 * This code is meant to be shared by many views throughout our app and should not
 * contain logic specifc to how your view is using it.
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.inputFieldStyles = exports.inputStyles = void 0;
const styled_components_1 = require("styled-components");
const typography_1 = require("../../styles/typography");
/**
 * Provides the common styling for the input elements themselves.
 */
exports.inputStyles = styled_components_1.css `
  ${typography_1.defaultText}

  appearance: none;
  background: none;
  border: 0;
  outline: none;
  padding: 0;

  &::placeholder {
    color: ${(props) => props.theme.colors.textLight};
  }

  ${(props) => props.disabled &&
    `
    color: ${props.theme.colors.textInactive};
  `}
`;
/**
 * Provides the common styling for the components that are designed
 * to look like a text input field.
 */
exports.inputFieldStyles = styled_components_1.css `
  box-sizing: border-box;
  background: #fff;
  border: 1px
    ${(props) => props.error ? props.theme.colors.error : props.theme.colors.borderDefault}
    solid;
  border-radius: ${(props) => props.theme.borderRadius};
  color: ${(props) => props.theme.colors.textInput};
  padding: 10px;
  position: relative;
  font-family: ${(props) => props.theme.font.family.sans};
  :focus-visible {
    outline: ${(props) => props.theme.outline};
  }
  ${(props) => props.disabled &&
    `
    background: ${props.theme.colors.backgroundInactive};
  `}
`;
